import createDocumentResource from 'src/actions/shared/createDocumentResource';

interface AppFeatures {}

const appFeaturesResource = createDocumentResource<AppFeatures>({
  name: 'appFeatures',
  endpoint: 'v1/orgs/:orgId/feature-set',
});
export default appFeaturesResource;
